import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { citationRequest } from '../shared/citationRequest';

@Injectable({
  providedIn: 'root'
})
export class RequestService {


  constructor(private http : HttpClient) { }

  deleteDigitizationRequest = (request: citationRequest) : Observable<void> => this.http.delete<void>(`../rl/main/digitization/${request.id}`);

  deleteCopyrightClearance = (request: citationRequest) : Observable<void> => this.http.delete<void>(`../rl/main/copyright/${request.id}`);


}
